import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isCountriesLoading: false,
  isStatesLoading: false,
  isCitiesLoading: false,
  isLocationsLoading: false,
  isLocationStatusesLoading: false,
  isTaxCodesLoading: false,
  isAddressLoading: false,
  error: null,
  country_id: null,
  state_id: null,
  city_id: null,
  countries: null,
  states: null,
  cities: null,
  locations: null,
  address: null,
  locationstatuses: null,
  taxcodes: null,
};

const slice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    // START LOADING
    startCountryLoading(state) {
      state.isCountriesLoading = true;
    },
    startStateLoading(state) {
      state.isStatesLoading = true;
    },
    startCityLoading(state) {
      state.isCitiesLoading = true;
    },
    startLocationsLoading(state) {
      state.isLocationsLoading = true;
    },
    startLocationStatusesLoading(state) {
      state.isLocationStatusesLoading = true;
    },
    startTaxCodesLoading(state) {
      state.isTaxCodesLoading = true;
    },
    startAddressLoading(state) {
      state.isAddressLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isCountriesLoading = false;
      state.isStatesLoading = false;
      state.isCitiesLoading = false;
      state.isLocationsLoading = false;
      state.isLocationStatusesLoading = false;
      state.isTaxCodesLoading = false;
      state.isAddressLoading = false;
      state.error = action.payload;
    },
    // GET COUNTRIES
    setCountries(state, action) {
      state.isCountriesLoading = false;
      state.countries = action.payload;
    },
    // GET STATES
    setStates(state, action) {
      state.isStatesLoading = false;
      state.states = action.payload;
    },
    // GET STATES
    setCities(state, action) {
      state.isCitiesLoading = false;
      state.cities = action.payload;
    },
    // GET LOCATIONS
    setLocations(state, action) {
      state.isLocationsLoading = false;
      state.locations = action.payload;
    },
    // GET LOCATIONSTATUSES
    setLocationStatuses(state, action) {
      state.isLocationStatusesLoading = false;
      state.locationstatuses = action.payload;
    },
    // GET TAXCODES
    setTaxCodes(state, action) {
      state.isTaxCodesLoading = false;
      state.taxcodes = action.payload;
    },
    setAddress(state, action) {
      state.isAddressLoading = false;
      state.address = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  hasError,
  setLocations,
  startCountryLoading,
  startStateLoading,
  startCityLoading,
  startLocationsLoading,
  startLocationStatusesLoading,
  startTaxCodesLoading,
  startAddressLoading,
} = slice.actions;

// ----------------------------------------------------------------------

export function getCountries() {
  return async () => {
    dispatch(slice.actions.startCountryLoading());
    try {
      const response = await axios.get('/dropdown/location/countries');
      dispatch(slice.actions.setCountries(response.data));
      dispatch(slice.actions.setStates([]));
      dispatch(slice.actions.setCities([]));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getStates(countryId = null) {
  const url = countryId !== null ? `/dropdown/location/states?country_id=${countryId}` : '/dropdown/location/states';
  return async () => {
    dispatch(slice.actions.startStateLoading());
    try {
      const response = await axios.get(url);
      dispatch(slice.actions.setStates(response.data));
      dispatch(slice.actions.setCities([]));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCities(stateId = null) {
  return async () => {
    dispatch(slice.actions.startCityLoading());
    try {
      const response = await axios.get(`/dropdown/location/cities?state_id=${stateId}`);
      dispatch(slice.actions.setCities(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getLocations(companyId = null) {
  return async () => {
    dispatch(slice.actions.startLocationsLoading());
    try {
      const response = await axios.get(`/dropdown/location/locations`, {
        params: {
          company_id: companyId,
        },
      });
      dispatch(slice.actions.setLocations(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAddress(params = {}) {
  return async () => {
    dispatch(slice.actions.startAddressLoading());
    try {
      const response = await axios.get(`/admin/location/get_all_address`, {
        params: params
      });
      dispatch(slice.actions.setAddress(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAvailableLocations(companyId = null) {
  return async () => {
    dispatch(slice.actions.startLocationsLoading());
    try {
      const response = await axios.get(`/dropdown/location/available_locations`, {
        params: {
          company_id: companyId,
        },
      });
      dispatch(slice.actions.setLocations(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getJobLocations(jobId = null) {
  return async () => {
    dispatch(slice.actions.startLocationsLoading());
    try {
      const response = await axios.get(`/admin/job/job_locations/${jobId}`);
      dispatch(slice.actions.setLocations(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getLocationStatuses() {
  return async () => {
    dispatch(slice.actions.startLocationStatusesLoading());
    try {
      const response = await axios.get(`/dropdown/location/location_statuses`);
      dispatch(slice.actions.setLocationStatuses(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getTaxCodes() {
  return async () => {
    dispatch(slice.actions.startTaxCodesLoading());
    try {
      const response = await axios.get(`/dropdown/location/tax_codes`);
      dispatch(slice.actions.setTaxCodes(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
